import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor, titles, urgentDate } from '../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {},
	error: {
		color: urgentDate,
		fontSize: 12,
		fontStyle: 'italic',
		paddingBottom: 5,
	},
	input: {
		marginBottom: 6,
		marginTop: 2,
	},
	inputLabel: {
		colors: titles,
		display: 'block',
		fontSize: 14,
		paddingBottom: 4,
	},
	locationOption: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		cursor: 'pointer',
		position: 'relative',
	},
	locationOptionIcon: {
		marginTop: 2,
	},
	locationOptionLabel: {
		marginLeft: 6,
	},
	addressText: {
		color: darkGrayFontColor,
		fontSize: 12,
	},
});
